import SearchInput from "@components/SearchInput";
import Api from "@services/Api";
import { RootState, useAppDispatch } from "@services/Redux";
import { fetchProducts, setProductFilterOrderBy, setProductFilterText, setProducts, setProductsFilterCurrentPage } from "@services/Redux/products";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { toastError } from "@utils/functions";
import * as React from "react";
import { FiChevronDown } from "react-icons/fi";
import { useSelector } from "react-redux";
import { CategoriesMenu } from "./components";
import Styled from "./styled";

const ProductsFilters: React.FC = () => {
  const company = useSelector((state: RootState) => state.company);
  const { filters } = useSelector((state: RootState) => state.products);
  const [categories, setCategories] = React.useState([]);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    fetchCategories();
    // eslint-disable-next-line
  }, []);

  const fetchCategories = async () => {
    try {
      const { data } = await Api.get(`/company/${company.data.id}/categories/cascade`);
      setCategories(data.categories);
    } catch (error) {
      console.log(error, "fetchCategories() error");
      toastError(error);
    }
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setProductFilterText(e.target.value));
  };

  const handleOrderByChange = (order: string) => {
    dispatch(setProductFilterOrderBy(order));
    clearProductsAndFetch();
  };

  const clearProductsAndFetch = () => {
    dispatch(setProductsFilterCurrentPage(1));
    dispatch(setProducts([]));
    dispatch(fetchProducts());
  };

  return (
    <Styled.FiltersContainer className={"py-2 pt-4"}>
      <div className={"row m-0"}>
        <div className={"col-12 mb-2"}>
          <SearchInput
            placeholder={"Pesquisar"}
            value={filters.searchText}
            onChange={handleSearchInputChange}
            onSearch={() => {
              clearProductsAndFetch();
            }}
            onClear={() => {
              dispatch(setProductFilterText(""));
              clearProductsAndFetch();
            }}
          />
        </div>
        <div className={"col-6"}>
          <CategoriesMenu categories={categories} />
        </div>
        <div className={"col-6"}>
          <Menu
            menuButton={
              <Styled.SelectButton>
                <span>
                  {filters.orderBy === "newer"
                    ? "Mais novos"
                    : filters.orderBy === "price-asc"
                    ? "Menor preço"
                    : filters.orderBy === "price-desc"
                    ? "Maior preço"
                    : "Ordernar por"}
                </span>
                <FiChevronDown size={26} />
              </Styled.SelectButton>
            }
            transition
          >
            <MenuItem
              onClick={() => {
                handleOrderByChange("newer");
              }}
            >
              Mais novos
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleOrderByChange("price-asc");
              }}
            >
              Menor preço
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleOrderByChange("price-desc");
              }}
            >
              Maior preço
            </MenuItem>
          </Menu>
        </div>
      </div>
    </Styled.FiltersContainer>
  );
};

export default ProductsFilters;
